import $ from 'jquery';
import * as dayjs from 'dayjs';
import * as advancedFormat from 'dayjs/plugin/advancedFormat';
import * as utc from 'dayjs/plugin/utc';
import * as timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

let setTime = function () {
  let time = dayjs().format('HH:mm z');
  $('[data-current-time]').html(time);
};

$(function () {
  setTime();
  setInterval(setTime, 60000);
});
